import type { FC } from "react";
import { useBoolean } from "usehooks-ts";

import { ManageSectionPagesModal } from "./ManageSectionPagesModal";

import { MOBILE_OVERLAY_ROUTE_QUERY_PARAM } from "components/constants";
import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";
import { LinkButton } from "mds/components/buttons/LinkButton";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { GearSettingsIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import {
  selectCurrentSectionIsLinked,
  selectHasAccessablePages,
  selectIsEditModeEnabled,
} from "store/selectors";
import { useQueryParamsManager } from "utils/routing";

export const ManageSectionPagesButton: FC = () => {
  const isMdOrLarger = useIsMdOrLarger();
  const { setQueryParams } = useQueryParamsManager();
  const isEditModeEnabled = useAppSelector(selectIsEditModeEnabled);
  const hasAssessablePages = useAppSelector(selectHasAccessablePages);
  const isInLinkedSection = useAppSelector(selectCurrentSectionIsLinked);

  const { value: dialogIsShown, setTrue: showDialog, setFalse: hideDialog } = useBoolean(false);

  if ((!isInLinkedSection && !isEditModeEnabled) || !hasAssessablePages) {
    return null;
  }

  const onClick = () => {
    if (isMdOrLarger) {
      showDialog();
    } else {
      setQueryParams({ [MOBILE_OVERLAY_ROUTE_QUERY_PARAM]: "manage_pages" });
    }
  };

  return (
    <>
      <LinkButton size="s" title={t("manage_section_pages_modal.title")} onClick={onClick}>
        <GearSettingsIcon />
        {t("manage_section_pages_modal.button")}
      </LinkButton>
      <Dialog
        dialogPanelClassName="w-[80vw] max-w-[1200px] pb-4"
        open={dialogIsShown}
        title={
          <span className="flex items-center gap-2">
            <GearSettingsIcon className="text-blue" size="m" />
            {t("manage_section_pages_modal.title")}
          </span>
        }
        onClose={hideDialog}
      >
        <ManageSectionPagesModal onClose={hideDialog} />
      </Dialog>
    </>
  );
};
